import { Upload } from 'antd'
import { Trash } from 'phosphor-react'
import { Image } from '@phosphor-icons/react'
import { Controller } from 'react-hook-form'
import styled from 'styled-components'
import { ActionButtons } from 'screens'

const ImagePreviewContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 16px;
`

const PreviewCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  border: 1px dotted gray;
  border-radius: 20px;
`

const PreviewWrapper = styled.div`
  position: relative;
  display: inline-block;
  &:hover .overlay {
    opacity: 1;
  }
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
`

const PreviewImage = styled.img`
  height: 200px;
  width: 200px;
  object-fit: cover;
  border: 2px dashed ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  &:hover {
    cursor: pointer;
  }
`

const StyledUploadButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  width: 200px;
  padding: 8px 16px;
  border: 1px solid #d9d9d9;
  border-radius: 50%;
  background: #f5f7ff;
  border: 2px dashed ${({ theme }) => theme.colors.primary};
  color: #000;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  span {
    color: ${({ theme }) => theme.colors.primary};
  }
  svg {
    width: 30px;
    height: 30px;
  }
`

export const CustomMediaUploader = ({
  name,
  control,
  fileList,
  errors,
  setFileList,
  showPreview,
}) => {
  const handleUploadChange = newFileList => {
    if (newFileList.length > 0) {
      const updatedFileList = newFileList?.map(file => {
        if (typeof file === 'string') {
          return file
        }
        return {
          ...file,
          preview: file.originFileObj
            ? URL.createObjectURL(file.originFileObj)
            : file.preview,
          type: file.type || 'image',
        }
      })
      setFileList(updatedFileList)
    } else {
      setFileList([])
    }
  }

  const handleRemove = (file, index) => {
    const filteredFiles = fileList.filter((_, i) => i !== index)
    setFileList(filteredFiles)
  }

  const handleEdit = file => {
    console.log('Edit clicked for:', file)
    // Add edit functionality here
  }

  return (
    <div className="ps-2">
      {errors?.[name] && fileList?.length === 0 && (
        <p className="error">{errors?.[name]?.message}</p>
      )}

      <Controller
        name={name}
        control={control}
        defaultValue={[]}
        render={() => (
          <>
            <Upload
              accept="image/*,video/mp4"
              multiple
              fileList={[]}
              onChange={info => handleUploadChange(info.fileList)}
              beforeUpload={() => false}
            >
              {fileList?.[0]?.preview ? (
                <PreviewWrapper>
                  <PreviewImage src={fileList[0].preview} alt="Preview" />
                  <Overlay className="overlay">
                    <ActionButtons onClick={() => handleEdit(fileList[0])}>
                      Edit
                    </ActionButtons>
                    <ActionButtons
                      onClick={(e) => {
                        e.stopPropagation(); // Prevents the click from reaching <Upload>
                        handleRemove(fileList[0], 0);
                      }}
                    >
                      Delete
                    </ActionButtons>
                  </Overlay>
                </PreviewWrapper>
              ) : (
                <StyledUploadButton hasImage={!!fileList.length}>
                  <Image size={32} color="#666666" weight="bold" />
                  <span> Click to upload</span> or drag and drop
                </StyledUploadButton>
              )}
            </Upload>
            {showPreview && (
              <ImagePreviewContainer>
                {fileList?.map((file, index) => (
                  <PreviewCard key={file.uid || index}>
                    {file.type === 'video/mp4' ? (
                      // eslint-disable-next-line jsx-a11y/media-has-caption
                      <video width="100" height="100" controls>
                        <source
                          src={typeof file === 'object' ? file.preview : file}
                          type="video/mp4"
                        />
                        Your browser does not support the video tag.
                      </video>
                    ) : (
                      <Image
                        src={typeof file === 'object' ? file.preview : file}
                        alt={file.name}
                        width={100}
                        height={100}
                        preview={false}
                      />
                    )}
                    <button
                      type="button"
                      onClick={() => handleRemove(file, index)}
                    >
                      <Trash className="fs-6" />
                    </button>
                  </PreviewCard>
                ))}
              </ImagePreviewContainer>
            )}
          </>
        )}
      />
    </div>
  )
}
